// What this laptop's graphics are, for every 3D screen that isn't the lobby (Lantern Line's alley, Restock's shop,
// Meteor's town) and for the lesson recorder. A student picks Auto, High, Medium or Low in the lobby's settings
// (LobbyStage.tsx, gk-graphics); on Auto, or on Low picked by hand, the lobby moves along its ladder and keeps where it
// settled for a week (lobby.ts). The class games read the same, so a laptop the lobby had to step down doesn't start
// each game at full size and stutter until it finds its feet again (Nov 2026: Lantern Line still read the key from
// before it was renamed, and Restock read nothing at all).

export const GRAPHICS_KEY = 'gk-graphics';
// a new name when how the lobby measures changes, so a wrong step kept from before is forgotten
export const SETTLED_KEY = 'gk-auto-settled-2';
export const LOW_RES = [0.75, 0.65, 0.55, 0.5]; // Low's picture sizes, one step each, after High (0) and Medium (1)
const WEEK = 7 * 864e5;

export type Tier = 'high' | 'medium' | 'low';

export interface Settled {
  mode: string; // 'auto', or 'low' (picked by hand: only the picture moves)
  level: number; // 0 High, 1 Medium, 2.. Low at LOW_RES[level - 2]
  at: number;
}

export function readSettled(): Settled | null {
  try {
    const v = JSON.parse(localStorage.getItem(SETTLED_KEY) ?? 'null') as Settled | null;
    if (v && typeof v.level === 'number' && typeof v.mode === 'string' && Date.now() - v.at < WEEK) return v;
  } catch {
    /* nothing kept */
  }
  return null;
}

const picked = (): string => {
  try {
    return localStorage.getItem(GRAPHICS_KEY) || 'auto';
  } catch {
    return 'auto';
  }
};

const tierOf = (level: number): Tier => (level <= 0 ? 'high' : level === 1 ? 'medium' : 'low');

// Where this laptop is on the ladder now: picked by hand, or where Auto settled (High until it has)
export function graphicsNow(): { mode: string; tier: Tier; level: number } {
  const p = picked();
  if (p === 'high' || p === 'medium') return { mode: p, tier: p, level: p === 'high' ? 0 : 1 };
  const mode = p === 'low' ? 'low' : 'auto';
  const s = readSettled();
  const level = s && s.mode === mode ? Math.round(s.level) : mode === 'low' ? 2 : 0;
  return { mode, tier: tierOf(level), level };
}

// for the lesson recorder: "auto medium", "auto low.55", "low.65", "high" (at most 12 letters)
export function graphicsLabel(): string {
  const g = graphicsNow();
  const tier = g.tier === 'low' ? `low${String(LOW_RES[Math.min(LOW_RES.length - 1, Math.max(0, g.level - 2))]).slice(1)}` : g.tier;
  return (g.mode === 'auto' ? `auto ${tier}` : tier).slice(0, 12);
}
